
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import "./About.css";
import AboutUsBannerMobile from "../assets/t_c_banner_mobile.webp";
import AboutUsBanner from "../assets/t_c_banner.webp";

export default function TermsCondition() {

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  // const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const bannerImage = isMobile ? AboutUsBannerMobile : AboutUsBanner;
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://shubhpaisa.com/SeoBix/seo_injection.php?webid=524fa94a44850852fe5b6a9e70bfe6cd&url=${encodedUrl}&baseUrl=https%3A%2F%2Fshubhpaisa.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      <section className="w-100 position-relative mb-5">
        <div className="container-fluid p-0">
          <div
            className="position-relative w-100 d-flex"
            style={{
              minHeight:
                windowWidth <= 768
                  ? "540px" // Mobile
                  : windowWidth <= 1024
                  ? "400px" // Tablet
                  : windowWidth <= 1600
                  ? "620px" // Medium Desktop
                  : "750px", // Large Desktop
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundImage: `url(${bannerImage})`,
              alignItems: windowWidth <= 768 ? "flex-start" : "center",
              paddingTop: windowWidth <= 768 ? "50px" : "0",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
              }}
            ></div>

            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-1"></div>
                <div
                  className="col-10"
                  style={{
                    position: "relative",
                    zIndex: 2,
                    width:
                      windowWidth <= 768
                        ? "90%"
                        : windowWidth <= 1024
                        ? "70%"
                        : "55%",
                    textAlign: windowWidth <= 768 ? "center" : "left",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: windowWidth <= 768 ? "center" : "flex-start",
                  }}
                >
                  <div className="text-gray">
                    <h1
                      className="fw-semibold mb-2"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "28px"
                            : windowWidth <= 1024
                            ? "30px"
                            : "35px",
                        textAlign: "left",
                        lineHeight: "1.2",
                        fontWeight: "700",
                      }}
                    >
                      Terms & Conditions
                    </h1>
                    <p
                      className="mb-4"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "16px"
                            : windowWidth <= 1024
                            ? "20px"
                            : "18px",
                        textAlign: "left",
                        maxWidth: "500px",
                      }}
                    >
                      The framework that ensures fairness and trust in every transaction.
                    </p>
                  </div>
                </div>
                <div className="col-1"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="row">
        <div className="col-1 d-none d-lg-block"></div>
        <div className="col-12 col-lg-10">
          <div className="terms-content mx-3">
            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">Objective:</h2>
              <p className="text-muted">
                ShubhPaisa Finance may collect and store information about you
                when you visit our site, use our services, or view our online
                advertisements. The information which ShubhPaisa Finance
                collects and stores during normal use of the site is used to
                monitor use of the site and to help further development of our
                products and services. We use this information to improve our
                Web-based offerings.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">Scope:</h2>
              <p className="text-muted">
                This policy applies to information collected by ShubhPaisa
                Finance through its websites.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">Collected Information:</h2>
              <p className="text-muted">
                ShubhPaisa Finance may collect personal information that you
                submit to us through the Services, which include:
              </p>
              <ul className="text-muted ps-4">
                <li className="mb-1">Name</li>
                <li className="mb-1">Home address</li>
                <li className="mb-1">Guardian's name (if minor)</li>
                <li className="mb-1">Email address</li>
                <li className="mb-1">Domain address</li>
                <li className="mb-1">Telephone number</li>
                <li className="mb-1">Date of birth</li>
                <li className="mb-1">Job position</li>
                <li className="mb-1">Occupation</li>
                <li className="mb-1">Company</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">
                User credential, or any information that you submit to us.
              </h2>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">
                Other personal information we collect may include:
              </h2>
              <ul className="text-muted ps-4">
                <li className="mb-1">
                  Financial information such as income, assets, and your
                  financial investment strategy and background
                </li>
                <li className="mb-1">
                  Documents that you provide to verify your identity (e.g.,
                  passport, utility bills, bank statements)
                </li>
                <li className="mb-1">Company incorporation details</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">
                ShubhPaisa Finance also may collect some information
                automatically, which include:
              </h2>
              <ul className="text-muted ps-4">
                <li className="mb-1">IP address</li>
                <li className="mb-1">
                  Information about your web browser software and version
                </li>
                <li className="mb-1">
                  General geographic location from IP address
                </li>
                <li className="mb-1">Website that referred you to us</li>
                <li className="mb-1">Similar technical information</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">
                We also may collect information about your activity on our
                websites, which might include:
              </h2>
              <ul className="text-muted ps-4">
                <li className="mb-1">Frequency of visits to our website</li>
                <li className="mb-1">Average length of visits</li>
                <li className="mb-1">Pages viewed during a visit</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">
                We may use various technologies to collect information about
                your activities on our websites, including:
              </h2>
              <ul className="text-muted ps-4">
                <li className="mb-1">
                  Cookies (If not selected may affect certain or all
                  functionalities)
                </li>
                <li className="mb-1">
                  Web Beacons / Web bugs (Measures user experience on our
                  website)
                </li>
              </ul>
              <p className="text-muted mt-3">
                We may combine your information, automatically gathered
                information and the information we collect through cookies/web
                beacons / web bugs, including information that we have collected
                about you, or information that we have obtained from other
                sources. We may aggregate any statistics or data that are
                collected, but we are under no obligation to do so.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">
                Use of collected Personal Information
              </h2>
              <p className="text-muted">
                ShubhPaisa Finance may use the personal information that is
                collected from you to provide requested products and services
                and for our internal business purposes, including, but not
                limited to:
              </p>
              <ul className="text-muted ps-4">
                <li className="mb-1">
                  Responding to your requests for our unique products and
                  services
                </li>
                <li className="mb-1">
                  Processing your transactions and providing you with
                  transaction-related services
                </li>
                <li className="mb-1">Evaluating your use of the services</li>
                <li className="mb-1">
                  Providing advertising for products and services that might
                  interest you
                </li>
                <li className="mb-1">
                  Communicating with you about products or services that may be
                  of interest
                </li>
                <li className="mb-1">
                  Maintaining and managing your account with us
                </li>
                <li className="mb-1">
                  Monitoring your compliance with terms and confirming your
                  identity
                </li>
                <li className="mb-1">
                  Performing other functions as described to you or pursuant to
                  your consent
                </li>
              </ul>
              <p className="text-muted mt-3">
                We may also use information like IP address to monitor and
                investigate violations of our terms and conditions. This may
                involve transferring your personal information to other
                countries which may not have the same privacy laws.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="fs-2 fw-semibold mb-4">
                How We Share Personal Information:
              </h2>

              <div className="mb-4">
                <h3 className="fs-4 fw-semibold mb-3">Service Providers</h3>
                <p className="text-muted">
                  We may share personal information with organizations or
                  individuals that perform functions on our behalf, such as
                  payment processors or data storage providers.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="fs-4 fw-semibold mb-3">Marketing</h3>
                <p className="text-muted">
                  We may share personal information with group companies. If you
                  do not want your information shared for marketing purposes,
                  contact us.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="fs-4 fw-semibold mb-3">Legal Matters</h3>
                <p className="text-muted">
                  We may share information in response to legal requests, to
                  defend against claims, or to protect rights and safety.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="fs-4 fw-semibold mb-3">Transactions</h3>
                <p className="text-muted">
                  Information may be shared in connection with major corporate
                  transactions.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="fs-4 fw-semibold mb-3">Other Purposes</h3>
                <p className="text-muted">
                  Information may be shared as described to you or with your
                  consent.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="fs-4 fw-semibold mb-3">Third Parties</h3>
                <p className="text-muted">
                  For user convenience, we may provide links to third-party
                  services. We are not responsible for their practices.
                </p>
              </div>
            </section>
          </div>
        </div>
         <div className="col-1 d-none d-lg-block"></div>
      </div>
    </>
  );
}


